import { device_specs } from 'z3k-parser/model/device-spec/specs';
import { isDevelopment } from 'utils';
function getSpec(key) {
    //in dev use yaml from code, need reload build after changes!
    if (isDevelopment()) {
        return () => device_specs[key];
    }
    return () => (server_spec?.[key] ?? device_specs[key]);
}
const devType2Spec = {
    'H2000+': getSpec('H2000+'),
    H2000_PRO: getH2000PROSpec,
    H1500_PRO: getSpec('H1500_PRO'),
    'H1000+': getSpec('H1000+'),
    H1000_PRO: getH1000PROSpec,
    H700_PRO: getSpec('H700_PRO'),
    'C2000+': getSpec('C2000+'),
    C2000_PRO: getC2000PROSpec,
    'SMART+': getSpec('SMART+'),
    H1V_PLUS: getSpec('H1V_PLUS'),
    CONNECT_PLUS: getSpec('CONNECT_PLUS'),
    CLIMATIC: getClimaticSpec,
    'CLIMATIC+': getClimaticSpec,
    CLIMATIC_PRO: getClimaticPROSpec,
    VALTEC_1: getSpec('VALTEC_1'),
    VALTEC_K300: getValtecK300Spec,
    VALTEC_K500: getValtecK500Spec,
    A300: getSpec('A300'),
    A400: getSpec('A300'),
    A400E: getSpec('A300'),
    STILL: getSpec('STILL'),
    H1V02_PRO: getSpec('H1V02_PRO'),
    H1_PRO: getSpec('H1_PRO'),
    LEMAX_PRO: getSpec('LEMAX_PRO'),
    H1V02_PRO_EBUS: getSpec('H1V02_PRO_EBUS'),
    SMART_ESP: getSpec('SMART_ESP'),
    SMART20_PRO: getSpec('SMART20_PRO'),
    //2022.08.10
    //https://git.microline.ru/zont/server/-/issues/1341
    H1V: getSpec('H1V'),
    SMART: getSpec('SMART'),
    CONNECT_ESP: getSpec('CONNECT_ESP'),
    ZONTINO: getSpec('ZONTINO'),
    SMART_ZOTA: getSpec('SMART_ZOTA'),
    BT_PLUS: getSpec('BT_PLUS'),
    ZE8482_extention: getSpec('ZE8482_extention'),
    ZE0000_extention: getSpec('ZE0000_extention'),
    SOCKETS_03: getSpec('SOCKETS_03'),
    SOCKETS_03_THERMOSTAT: getSpec('SOCKETS_03_THERMOSTAT'),
    PANEL_LCD_128x64_732: getSpec('PANEL_LCD_128x64_732'),
};
let server_spec = {};
let is_first_load = true;
function firstUpdateServerSpec() {
    if (window._ui?.store && is_first_load) {
        is_first_load = false;
        server_spec = window._ui.store.getState()?.device_spec.spec || {};
        window._ui.store.subscribe(() => (server_spec = window._ui.store.getState()?.device_spec.spec || {}));
    }
}
/**
 * @function
 * Узнаём умелки устройства
 * @param dev_type - тип устройства
 * @param hw_type - тип платы
 * @return Z3KDeviceFeaturesSpec
 */
export function getDeviceSpec(dev_type, hw_type) {
    firstUpdateServerSpec();
    const spec = devType2Spec[dev_type] ?? (() => device_specs['H2000+']);
    return spec(hw_type);
}
export function getDeviceSpecV2(dev_type, hw_type) {
    firstUpdateServerSpec();
    if (dev_type == null) {
        return null;
    }
    const spec = devType2Spec[dev_type];
    if (spec == null) {
        return null;
    }
    return spec(hw_type);
}
export function hasModbusSupport(device_info) {
    if (!getDeviceSpec(device_info.name, device_info.hardware).io.has_modbus)
        return false;
    const firmware = parseInt(device_info.firmware);
    return ((firmware >= 2 && ['301', '302'].includes(device_info.hardware)) ||
        (firmware >= 135 && firmware <= 140) ||
        firmware >= 162);
}
function getH2000PROSpec(hw_type) {
    switch (hw_type) {
        case '723':
            return getSpec('H2000_PRO_723')(hw_type);
        default:
            return getSpec('H2000_PRO')(hw_type);
    }
}
function getH1000PROSpec(hw_type) {
    switch (hw_type) {
        case '722':
            return getSpec('H1000_PRO_722')(hw_type);
        default:
            return getSpec('H1000_PRO')(hw_type);
    }
}
function getC2000PROSpec(hw_type) {
    switch (hw_type) {
        case '724':
            return getSpec('C2000_PRO_724')(hw_type);
        default:
            return getSpec('C2000_PRO')(hw_type);
    }
}
function getClimaticSpec(hw_type) {
    switch (hw_type) {
        case '620':
            return getSpec('CLIMATIC_620')(hw_type);
        case '621':
        case '622':
        default:
            return getSpec('CLIMATIC')(hw_type);
    }
}
function getClimaticPROSpec(hw_type) {
    switch (hw_type) {
        case '715':
            return getSpec('CLIMATIC_PRO_715')(hw_type);
        case '718':
            return getSpec('CLIMATIC_PRO_718')(hw_type);
        case '716':
        case '717':
        default:
            return getSpec('CLIMATIC_PRO')(hw_type);
    }
}
function getValtecK300Spec(hw_type) {
    switch (hw_type) {
        case '644':
            return getSpec('ValtecK300_644')(hw_type);
        case '643':
        default:
            return getSpec('ValtecK300_643')(hw_type);
    }
}
function getValtecK500Spec(hw_type) {
    switch (hw_type) {
        default:
            return getSpec('VALTEC_K500')(hw_type);
    }
}
// const devType: Record<string, (hw_type: string) => boolean> = {
//     H2000_PRO: getH2000PRO_V2,
//     H1000_PRO: getH1000PRO_V2,
//     C2000_PRO: getC2000PRO_V2,
// };
// TRUST ME! need other method for detect device capabilities (device spec maybe)
// export function isDevicePRO_V2(dev_type: string, hw_type: string): boolean {
//     const spec = devType[dev_type];
//     if (spec == null) {
//         return false;
//     }
//     return spec(hw_type);
// }
//
// function getH1000PRO_V2(hw_type: string | undefined | null): boolean {
//     switch (hw_type) {
//         case '722':
//             return true;
//         default:
//             return false;
//     }
// }
// function getH2000PRO_V2(hw_type: string | undefined | null): boolean {
//     switch (hw_type) {
//         case '723':
//             return true;
//         default:
//             return false;
//     }
// }
//
// function getC2000PRO_V2(hw_type: string | undefined | null): boolean {
//     switch (hw_type) {
//         case '724':
//             return true;
//         default:
//             return false;
//     }
// }
